import axios from 'axios';
import { API_INFO } from 'constants';
import { localizePathname } from 'utils/localePath';


export function processAuthors(object) {
  if (!object.autor) return null;
  let textAutor = '';
  const autores = object.autor
    .map((value, i) => {
      return value.nombre_autor;
    })
    .join(',');
  textAutor = autores ? `${autores}` : 'No especifica';
  return textAutor;
}

export function truncate(input, length) {
  if (input.length > length) {
    return input.substring(0, length) + '...';
  } else {
    return input;
  }
}

export function storeLocal(key, data, isObject) {
  isObject ? localStorage.setItem(key, JSON.stringify(data)) : localStorage.setItem(key, data);
}

export function unSetLocal(key) {
  localStorage.removeItem(key);
}

export function checkEmpty(object) {
  return Object.keys(object).length > 0 ? true : false;
}

export function capitalize(word) {
  if (typeof word !== 'string') return '';
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

/**
 * @param {string} key - the key property to check out in the localstorage
 */
export const getItemStore = (key) => localStorage.getItem(key);

export const getValueStorage = (key) => localStorage.getItem(key);

export const formatDateToSpanish = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const formatDateToSpanishWithTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};

export const convertDateToDDMMYYYY = (dateISO) => {
  const date = new Date(dateISO);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month}/${year}`;
}

export const detailTypeProductRedirect = (product, assigned_library) => {
  let path;
  switch (product?.type) {
    case 'book':
    case 'libro':
      path = `/${assigned_library}/libro/${product?.id}`;
      break;
    case 'film':
    case 'pelicula':
      path = `/${assigned_library}/pelicula/${product?.id}`;
      break;
    case 'music':
    case 'musica':
      path = `/${assigned_library}/musica/${product?.id}`;
      break;
    case 'merchandising':
      path = `/${assigned_library}/merchandising/${product?.id}`;
      break;
    case 'other':
      return;
    default:
      break;
  }

  if (!path) return path;

  const pathnameForLocale =
    typeof window !== 'undefined' ? window.location.pathname : '/';

  return localizePathname(path, pathnameForLocale);
};

export const getTypeProduct = (t, type) => {
  switch (type) {
    case 'book':
      return t('book');
    case 'film':
      return t('cinema');
    case 'music':
      return t('music');
    case 'merchandising':
      return t('merchandising');
    case 'other':
      return t('others');
    default:
      break;
  }
};

export const goUp = () => {
  window.scrollTo(0, 0);
};

export const addToFormData = (formData, values) => {
  Object.keys(values).forEach(key => {
    formData.append(key, values[key]);
  });
};

export const capitalizeText = (text) =>{
  if (!text) return ''; 
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

export const validateEmailOrPhone = (input) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // const phoneRegex = /^\+?\d{1,4}?[\d\s-]{7,15}$/;

  if (emailRegex.test(input)) {
    return { isValid: true, type: 'email' };
  }

  // if (phoneRegex.test(input)) {
  //   return { isValid: true, type: 'phone' };
  // }

  return { isValid: false, type: null };
};

export const validateUrl = (inputUrl) => {
  const urlPattern = new RegExp('^(https?:\\/\\/)?' +
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
    '((\\d{1,3}\\.){3}\\d{1,3}))' +
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
    '(\\?[;&a-z\\d%_.~+=-]*)?' +
    '(\\#[-a-z\\d_]*)?$', 'i');
  return !!urlPattern.test(inputUrl);
};

export const exportExcel = async (endpoint, query, token, name, setEnabled, extension = 'xlsx') => {
  axios({
    url: API_INFO + endpoint,
    method: 'GET',
    params: query,
    responseType: 'blob',
    headers: {
      Authorization: 'JWT ' + token,
    },
  })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${name}_${new Date().toISOString()}.${extension}`);
      document.body.appendChild(link);
      link.click();
      if (response?.status === 401) {
        window.location.href = '/intranet/login';
      }
      setEnabled(true);
    })
    .catch((error) => {
      console.log('Error exporting Excel ->', error);
      setEnabled(true);
    });
};

export const verificateNullValue= (value) => {
  return  value == undefined || value == null  || value == 'null'? '' : value;
}





